import { mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as Api from '../../../../store/bulk/update/bulk.update.api';
import { BulkActions } from '../../../../enums/bulk-actions';

const makeApiCallWithIds = (job) => {
  const { model, ids } = job;

  const { shipByDate, daysToAdd } = model;

  const request = {
    filter: {
      fulfillmentPlanId: ids,
    },
    shipByDate,
    daysToAdd,
  };

  return Api.bulkUpdateSetShipByDate(request).pipe(
    mergeMap((data) => {
      return of(data);
    }),
  );
};

const makeApiCallWithJobGuid = (job) => {
  const {
    model,
    jobData: { bulkUpdateJobGuid },
  } = job;

  const { shipByDate, daysToAdd } = model;

  const request = {
    bulkUpdateJobGuid,
    shipByDate,
    daysToAdd,
  };

  return Api.bulkSetShipByDateUpdate(request).pipe(
    mergeMap((data) => {
      return of(data);
    }),
  );
};

export const salesOrder = {
  id: 'sales-order',
  applicableBulkActions: [BulkActions.shipByDate],

  handler: (job) => {
    const {
      jobData: { bulkUpdateJobGuid },
    } = job;

    const makeApiCall$ = bulkUpdateJobGuid ? makeApiCallWithJobGuid : makeApiCallWithIds;

    return makeApiCall$(job);
  },
};
